import AffectationPage from '@/views/affectation'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/affectation/')({
  component: AffectationPage,
})
